import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faArrowRight, faArrowRightFromBracket, faArrowsToCircle, faArrowUpRightFromSquare, faBuilding, faCalendarDays, faChartLine, faCheck, faChevronRight, faCodeCompare, faDiagramProject, faDownload, faEnvelopeCircleCheck, faExclamationTriangle, faEye, faEyeSlash, faFloppyDisk, faGear, faGripVertical, faKey, faListCheck, faLock, faMoneyBillTrendUp, faMoneyCheck, faPen, faPerson, faPlus, faPuzzlePiece, faRotateLeft, faSearch, faSitemap, faTrash, faUmbrella, faUpload, faUserCheck, faUserCircle, faUserShield, faUserTie, faXmark } from '@fortawesome/free-solid-svg-icons';
//import {  } from '@fortawesome/free-regular-svg-icons';

library.add(


    faCheck,
    faRotateLeft,
    faArrowRightFromBracket,
    faArrowsToCircle,
    faListCheck,
    faDiagramProject,
    faMoneyCheck,
    faChartLine,
    faPerson,
    faUserCheck,
    faUmbrella,
    faCodeCompare,
    faSitemap,
    faBuilding,
    faPen,
    faArrowLeft,
    faFloppyDisk,
    faPlus,
    faTrash,
    faEyeSlash,
    faEye,
    faXmark,
    faLock,
    faChevronRight,
    faPuzzlePiece,
    faArrowRight,
    faKey,
    faUserShield,
    faEnvelopeCircleCheck,
    faUserCircle,
    faMoneyBillTrendUp,
    faUpload,
    faDownload,
    faArrowUpRightFromSquare,
    faCalendarDays,
    faGripVertical,
    faExclamationTriangle,
    faGear,
    faSearch,
    faUserTie

);
